import {useEffect} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FaqSection} from "@pg-mono/faq";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {LeadModal} from "../../application/components/LeadModal";
import {ForYouModal} from "../../for_you/components/ForYouModal";
import {normalizeRegionDataToPayload, promotionListSearchHit} from "../../tracking/algolytics_hits/promotion_listing_search_hit";
import {normalizeOfferListIntoSearchPayload} from "../../tracking/algolytics_hits/utils/normalize_offer_data_to_payload";
import {PromotionInternalLinks} from "../components/PromotionInternalLinks";
import {buildPromotionListUrl} from "../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingType} from "../helpers/promotion_listing_config";
import {PromotionType} from "../helpers/PromotionType";
import {usePromotionTypeListByCurrentRegion} from "../hooks/use_promotion_type_list_by_region";
import {PromotionListBreadcrumbs} from "../list/components/PromotionListBreadcrumbs";
import {PromotionListHeader} from "../list/components/PromotionListHeader";
import {PromotionListListSection} from "../list/components/PromotionListListSection";
import {PromotionListTabs} from "../list/components/PromotionListTabs";
import {usePromotionListMaxPage} from "../list/hooks/usePromotionListMaxPage";

export const PromotionListView = () => {
    const promotions = useSelector((state: IRPStore) => state.promotionList.promotions);
    const searchOfferType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type) as PromotionType;
    const searchRegions = useSelector((state: IRPStore) => state.search.formValues.search.regions);
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const faq = useSelector((state: IRPStore) => state.faq.data);
    const location = useLocation();
    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const {isMobile} = useUserDevice();
    const activeListingType = getPromotionListingType(searchOfferType);
    const activeListingConfig = getPromotionListingConfig(activeListingType);
    const {promotionLinks} = usePromotionTypeListByCurrentRegion(activeListingType);
    const internalLinks = region ? promotionLinks : getBasePromotionCityLinks(activeListingType, activeListingConfig.fullLabel);

    const maxPage = usePromotionListMaxPage();

    useEffect(() => {
        const searchOptions = normalizeRegionDataToPayload(searchRegions?.[0]);
        const payload = normalizeOfferListIntoSearchPayload(promotions.map((promotion) => promotion.offer));

        promotionListSearchHit({...searchOptions, category: activeListingConfig.fullLabel}, payload);
    }, [searchRegions, activeListingConfig.fullLabel, promotions]);

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query);
    };

    return (
        <article>
            <Container>
                <PromotionListBreadcrumbs />
                <PromotionListHeader className={css({pt: 2, pb: 3, md: {pt: 4, pb: 4}})} />
                <PromotionListTabs />
                <PromotionListListSection />
                <Pagination
                    getPageLink={getPageLink}
                    pageCount={maxPage}
                    currentPage={currentPage}
                    size={isMobile ? PaginationSize.MD : PaginationSize.LG}
                    className={css({mt: 3, mb: 6, md: {mt: 4, mb: 10}})}
                    siblingsCount={isMobile ? 0 : 1}
                />
                {currentPage === 1 && internalLinks.length > 0 && <PromotionInternalLinks className={css({mb: 8, md: {mt: 4}})} links={internalLinks} />}
            </Container>
            {currentPage === 1 && <FaqSection faqContent={faq} />}
            <LeadModal />
            <ForYouModal />
        </article>
    );
};

const basePromotionCities = [
    {name: "Warszawa", slug: "warszawa"},
    {name: "Kraków", slug: "krakow"},
    {name: "Wrocław", slug: "wroclaw"},
    {name: "Poznań", slug: "poznan"},
    {name: "Gdańsk", slug: "gdansk"},
    {name: "Łódź", slug: "lodz"},
    {name: "Katowice", slug: "katowice"},
    {name: "Lublin", slug: "lublin"}
];

const getBasePromotionCityLinks = (type: PromotionType, label: string) => {
    return basePromotionCities.map((city) => ({
        href: buildPromotionListUrl({type, region: city.slug}),
        text: `${label} ${city.name}`
    }));
};
import {useEffect} from "react";
import {useSelector} from "react-redux";
import {useLocation} from "react-router";
import {css} from "@panda/css";

import {Container} from "@pg-design/grid-module";
import {Pagination, PaginationSize} from "@pg-design/pagination-module";
import {FaqSection} from "@pg-mono/faq";
import {appendQueryString, parseSearch, validateQuery} from "@pg-mono/request";
import {useUserDevice} from "@pg-mono/user-device";

import {IRPStore} from "../../app/rp_reducer";
import {LeadModal} from "../../application/components/LeadModal";
import {ForYouModal} from "../../for_you/components/ForYouModal";
import {normalizeRegionDataToPayload, promotionListSearchHit} from "../../tracking/algolytics_hits/promotion_listing_search_hit";
import {normalizeOfferListIntoSearchPayload} from "../../tracking/algolytics_hits/utils/normalize_offer_data_to_payload";
import {PromotionInternalLinks} from "../components/PromotionInternalLinks";
import {buildPromotionListUrl} from "../helpers/build_promotion_list_url";
import {getPromotionListingConfig, getPromotionListingType} from "../helpers/promotion_listing_config";
import {PromotionType} from "../helpers/PromotionType";
import {usePromotionTypeListByCurrentRegion} from "../hooks/use_promotion_type_list_by_region";
import {PromotionListBreadcrumbs} from "../list/components/PromotionListBreadcrumbs";
import {PromotionListHeader} from "../list/components/PromotionListHeader";
import {PromotionListListSection} from "../list/components/PromotionListListSection";
import {PromotionListTabs} from "../list/components/PromotionListTabs";
import {usePromotionListMaxPage} from "../list/hooks/usePromotionListMaxPage";

export const PromotionListView = () => {
    const promotions = useSelector((state: IRPStore) => state.promotionList.promotions);
    const searchOfferType = useSelector((state: IRPStore) => state.promotionList.form.formValues.type) as PromotionType;
    const searchRegions = useSelector((state: IRPStore) => state.search.formValues.search.regions);
    const region = useSelector((state: IRPStore) => state.promotionList.region);
    const faq = useSelector((state: IRPStore) => state.faq.data);
    const location = useLocation();
    const query = parseSearch(location.search);
    const currentPage = typeof query.page === "string" ? parseInt(query.page, 10) : 1;
    const {isMobile} = useUserDevice();
    const activeListingType = getPromotionListingType(searchOfferType);
    const activeListingConfig = getPromotionListingConfig(activeListingType);
    const {promotionLinks} = usePromotionTypeListByCurrentRegion(activeListingType);
    const internalLinks = region ? promotionLinks : getBasePromotionCityLinks(activeListingType, activeListingConfig.fullLabel);

    const maxPage = usePromotionListMaxPage();

    useEffect(() => {
        const searchOptions = normalizeRegionDataToPayload(searchRegions?.[0]);
        const payload = normalizeOfferListIntoSearchPayload(promotions.map((promotion) => promotion.offer));

        promotionListSearchHit({...searchOptions, category: activeListingConfig.fullLabel}, payload);
    }, [searchRegions, activeListingConfig.fullLabel, promotions]);

    const getPageLink = (page: number) => {
        const query = validateQuery(["page"], parseSearch(location.search), page >= 2 ? {page: page.toString()} : {});

        return appendQueryString(location.pathname, query);
    };

    return (
        <article>
            <Container>
                <PromotionListBreadcrumbs />
                <PromotionListHeader className={css({pt: 2, pb: 3, md: {pt: 4, pb: 4}})} />
                <PromotionListTabs />
                <PromotionListListSection />
                <Pagination
                    getPageLink={getPageLink}
                    pageCount={maxPage}
                    currentPage={currentPage}
                    size={isMobile ? PaginationSize.MD : PaginationSize.LG}
                    className={css({mt: 3, mb: 6, md: {mt: 4, mb: 10}})}
                    siblingsCount={isMobile ? 0 : 1}
                />
                {currentPage === 1 && internalLinks.length > 0 && <PromotionInternalLinks className={css({mb: 8, md: {mt: 4}})} links={internalLinks} />}
            </Container>
            {currentPage === 1 && <FaqSection faqContent={faq} />}
            <LeadModal />
            <ForYouModal />
        </article>
    );
};

const basePromotionCities = [
    {name: "Warszawa", slug: "warszawa"},
    {name: "Kraków", slug: "krakow"},
    {name: "Wrocław", slug: "wroclaw"},
    {name: "Poznań", slug: "poznan"},
    {name: "Gdańsk", slug: "gdansk"},
    {name: "Łódź", slug: "lodz"},
    {name: "Katowice", slug: "katowice"},
    {name: "Lublin", slug: "lublin"}
];

const getBasePromotionCityLinks = (type: PromotionType, label: string) => {
    return basePromotionCities.map((city) => ({
        href: buildPromotionListUrl({type, region: city.slug}),
        text: `${label} ${city.name}`
    }));
};
